React = require 'react'
InviteTeamMembersAutoComplete = require 'views/organization/invite-team-members-autocomplete-component'
OrganizationActionsStatusComponent = require 'views/organization/organization-actions-status-component'
t = require('views/internal/recup-with-helpers')('org_members')

module.exports = class OrganizationActionsComponent extends React.Component

  constructor: (props) ->
    super
    @state =
      showingAll: false

  render: t.renderable ->
    {
      canManageMembers,
      openManageMembers,
      filter,
      onFilterChange,
      onShowAllChange,
      inviteTeamMembers,
      orgMemberCount,
      orgIsEmpty,
      guestMemberCount,
      isEnterpriseAdmin,
      orgName,
      memberTypeFilter,
      orgId,
      hasBC,
      ownsOrg,
      orgIsPO,
      model,
      bulkAddMemberErrors
    } = @props
    { showingAll } = @state

    toggleShowingAll = =>
      showingAll = !@state.showingAll
      @setState({ showingAll })
      onShowAllChange(showingAll)

    onDismissStatus = (e) =>
      model.updateBulkAddMemberErrors(null)

    t.div ->
      t.div '.org-members-section', {
        class: t.classify({ active: memberTypeFilter == 'team-member' })
      }, ->
        if orgIsEmpty && !bulkAddMemberErrors
          t.div '.org-members-empty-container', =>
            t.img
              className: 'org-members-team-illustration'
              alt: t.l 'invite-your-team'
              src: require('images/organization/new-team.svg')
            t.div '.org-members-empty-content', =>
              t.h1 '.org-members-heading', -> t.format 'invite-your-team'
              t.p '.org-members-subheading', -> t.format 'trello-works-best'
              t.addElement React.createElement InviteTeamMembersAutoComplete,
                placeholder: t.l 'invite-input-placeholder'
                orgId: orgId
                model: model

          if hasBC and !orgIsPO and !isEnterpriseAdmin
            t.p '.org-members-empty-bc-billing.quiet', ->
              t.icon 'enterprise'
              t.format 'inviting-new-members-will-update-billing'
        else
          t.div '.org-members-actions-container', ->
            t.div '.org-members-actions-header', ->
              t.h1 ->
                t.format 'team-members'
                t.raw '&nbsp;'
                t.span '.team-member-count', -> t.text "(#{ orgMemberCount })"
                t.icon 'enterprise'

              t.p ->
                if model.belongsToRealEnterprise() && (canManageMembers || isEnterpriseAdmin)
                  t.format 'team-members-view-enterprise'
                else if hasBC and canManageMembers and !orgIsPO
                  t.format 'team-members-view-bc'
                else
                  t.format 'team-members-view'
            if bulkAddMemberErrors
              t.addElement React.createElement OrganizationActionsStatusComponent,
                statusMessages: bulkAddMemberErrors
                onDismiss: onDismissStatus

            t.div '.org-members-actions', ->
              t.div '.org-members-actions-search', ->
                t.input '.org-members-page-navigation-input',
                  type: 'text'
                  placeholder: t.l 'filter-by-name'
                  value: filter
                  onChange: (e) ->
                    onFilterChange(e.target.value)
              t.div '.org-members-actions-add', ->
                if canManageMembers
                  t.b inviteTeamMembers, { class: 'primary button-link autowrap' }, ->
                    t.icon 'add-member', 'invite-team-members'

      t.div '.org-members-section', {
        class: t.classify({ active: memberTypeFilter == 'guest' })
      }, ->
        if !guestMemberCount
          t.div '.org-members-empty-container', ->
            t.img
              className: 'org-members-guest-illustration'
              alt: t.l 'boards-shared-with-friends'
              src: require('images/organization/guests.svg')
            t.div '.org-members-empty-content', ->
              t.h1 '.org-members-heading', ->
                t.format 'boards-shared-with-friends'
              t.p '.org-members-subheading', ->
                t.format 'if-client-contractors'
        else
          t.div '.org-members-actions-container', ->
            t.div '.org-members-actions-header', ->
              t.h1 ->
                t.format 'guests'
                t.raw '&nbsp;'
                t.span '.guest-member-count', -> t.text "(#{ guestMemberCount })"
              t.p ->
                if model.belongsToRealEnterprise() && (canManageMembers || isEnterpriseAdmin)
                  t.format 'guests-view'
                  t.raw '<br/>'
                  t.format 'guests-view-enterprise'
                else if hasBC and ownsOrg and canManageMembers
                  t.format 'guests-view-bc'
                else
                  t.format 'guests-view'
            if bulkAddMemberErrors
              t.addElement React.createElement OrganizationActionsStatusComponent,
                statusMessages: bulkAddMemberErrors
                onDismiss: onDismissStatus

            t.div '.org-members-actions', ->
              t.div '.org-members-actions-search', ->
                t.input '.org-members-page-navigation-input',
                  type: 'text'
                  placeholder: t.l 'filter-by-name'
                  value: filter
                  onChange: (e) ->
                    onFilterChange(e.target.value)




// WEBPACK FOOTER //
// ./app/scripts/views/organization/organization-actions-component.coffee